import React from 'react'

import { useAppInfo } from 'hooks/useAppInfo'
import { usLanguages } from 'languages/ub'
import { UsBranchSupportTemplate } from 'templates/UsBranchSupportTemplate'

type AvailableLangs = 'pt' | 'es' | 'en'

export const UbSupportPage = () => {
  const { appLanguage } = useAppInfo()
  const urlParams = new URLSearchParams(window.location.search)

  let lang: AvailableLangs = appLanguage

  const validLangs = ['pt', 'en', 'es']
  const urlLang = urlParams.get('lang') || ''

  if (validLangs.includes(urlLang)) {
    lang = urlLang as AvailableLangs
  }

  const dictionary = usLanguages[lang].support

  return <UsBranchSupportTemplate dictionary={dictionary} />
}
